import { GridFooterCellProps } from '@progress/kendo-react-grid';

const BudgetPeriodFooterCell = (props: GridFooterCellProps) => (
  <td>
    <p className="text-left">Total</p>
  </td>
);

export default BudgetPeriodFooterCell;
